// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statistics-items {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.statistics-items__list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
}
.statistics-items__list-big {
  grid-template-columns: 1.4fr 1fr 0.6fr;
}
@media (max-width: 1920px) {
  .statistics-items__list-big {
    grid-template-columns: 1.2fr 1fr 1fr;
  }
}
@media (max-width: 1500px) {
  .statistics-items__list {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 992px) {
  .statistics-items__list {
    grid-template-columns: 1fr;
  }
}
.statistics-items__transfer-tabs {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.statistics-items__transfer-tab {
  border: 0;
  padding: 10px 14px;
  border-radius: 12px;
  cursor: pointer;
  background: #1e2025;
  color: #fff;
  font-size: 16px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.statistics-items__transfer-tab:hover {
  background: #000;
}
.statistics-items__transfer-tab--active {
  background: #131313;
}
.statistics-items__chart-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
}
.statistics-items__chart-group {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.statistics-items .select-tab {
  width: auto;
  min-width: 100px;
  margin: 0;
}
.statistics-items .select-tab .select__active {
  background: #1e2025;
  border: 0;
  border-radius: 12px;
  padding: 10px 14px;
  height: auto;
  min-height: 40px;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.2s ease;
}
.statistics-items .select-tab .select__active:hover {
  background: #000;
}
.statistics-items .select-tab .select__label {
  display: none;
}
.statistics-items .select-tab .select__current {
  font-size: 16px;
  color: #fff;
  font-weight: 400;
  padding: 0;
  margin: 0;
}
.statistics-items .select-tab .select__arrow {
  position: relative;
  right: auto;
  top: auto;
  transform: none;
  display: flex;
  align-items: center;
  width: auto;
  height: auto;
}
.statistics-items .select-tab .select__arrow svg path {
  stroke: #fff;
}
.statistics-items .select-tab.active .select__active {
  background: #131313;
}
.statistics-items .select-tab .select__items {
  background: #1e2025;
  border: 1px solid #333;
  border-radius: 12px;
  margin-top: 5px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.5);
}
.statistics-items .select-tab .select__items .select__item {
  color: #fff;
  padding: 10px 14px;
}
.statistics-items .select-tab .select__items .select__item:hover {
  background: rgba(255, 255, 255, 0.1);
}
.statistics-items .select-tab .select__items .select__item.active {
  color: #277DFF;
}
.statistics-items__filter {
  width: 100%;
}
.statistics-items__filter-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.statistics-items__filter-field {
  min-width: 220px;
  flex: 1 1 220px;
}
.statistics-items__periods {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 12px;
  width: 100%;
  min-width: 0;
}
.statistics-items__periods-grid > div, .statistics-items__periods-all > div {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 18px;
  transition: all 0.2s ease;
  min-height: 48px;
  box-sizing: border-box;
  overflow: hidden;
  min-width: 0;
  background-color: rgba(39, 125, 255, 0.13);
  color: #277DFF;
}
@media (max-width: 767px) {
  .statistics-items__periods-grid > div, .statistics-items__periods-all > div {
    width: 100%;
  }
}
.statistics-items__periods-grid > div.is-green, .statistics-items__periods-all > div.is-green {
  background-color: rgba(0, 227, 150, 0.13);
  color: #00E396;
}
.statistics-items__periods-grid > div.is-red, .statistics-items__periods-all > div.is-red {
  background-color: rgba(255, 69, 96, 0.13);
  color: #FF4560;
}
.statistics-items__periods-grid > div.is-purple, .statistics-items__periods-all > div.is-purple {
  background-color: rgba(119, 93, 208, 0.13);
  color: #775DD0;
}
.statistics-items__periods-grid > div.is-orange, .statistics-items__periods-all > div.is-orange {
  background-color: rgba(254, 176, 25, 0.13);
  color: #FEB019;
}
.statistics-items__periods-grid > div span, .statistics-items__periods-all > div span {
  color: #fff;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.statistics-items__periods-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 8px 12px;
  align-content: flex-start;
  width: 100%;
  min-width: 0;
  flex: 1 1;
}
.statistics-items__periods-price {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.statistics-items__periods-all {
  display: flex;
  align-items: stretch;
  flex-shrink: 0;
  flex-basis: 150px;
  min-width: 150px;
  max-width: 150px;
}
.statistics-items__periods-all > div {
  width: 100%;
}
@media (max-width: 576px) {
  .statistics-items__periods {
    flex-direction: column;
  }
  .statistics-items__periods-grid {
    grid-template-columns: 1fr;
    flex: unset;
  }
  .statistics-items__periods-all {
    justify-content: flex-start;
    flex-basis: auto;
    min-width: 0;
    max-width: none;
  }
}
.statistics-items__list-selector {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 3px;
  max-width: 100%;
  align-items: flex-start;
  align-content: flex-start;
  max-height: 300px;
  overflow: auto;
}
.statistics-items__list-selector--small {
  grid-template-columns: 1fr !important;
}
.statistics-items__list-selector-group {
  display: grid;
  gap: 3px;
  width: 100%;
  grid-template-columns: 1fr 1fr !important;
}
.statistics-items__list-selector-counter {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.statistics-items__list-selector-counter-main {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}
.statistics-items__list-selector-counter-main b {
  position: relative;
  display: inline-block;
  top: -1px;
  font-size: 12px;
  color: #fff;
  line-height: 100%;
}
.statistics-items__list-selector-counter-main span {
  font-size: 12px;
}
.statistics-items__list-selector-counter-main span:first-child {
  font-size: 20px;
  color: #fff;
}
.statistics-items__list-selector-counter-total {
  position: relative;
  font-size: 11px;
  display: inline-flex;
  gap: 8px;
  flex-direction: column;
  padding: 8px 12px;
  border-radius: 12px;
  background: #131313;
  color: #fff;
  flex-shrink: 0;
  text-align: center;
  flex-wrap: wrap;
}
.statistics-items__list-selector-counter-total span {
  display: flex;
  flex-direction: column;
}
.statistics-items__list-selector-counter-total--row {
  flex-direction: row;
  text-align: center;
  gap: 2px;
  flex-wrap: unset;
  width: 100%;
}
.statistics-items__list-selector-counter-total--row span {
  display: flex;
  flex-direction: column;
}
.statistics-items__list-selector-item {
  padding: 5px;
  border-radius: 12px;
  cursor: pointer;
}
.statistics-items__list-selector-item--active {
  border: 1px solid #2670dc;
  background-color: rgba(39, 125, 255, 0.13);
}
.statistics-items__inner {
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  gap: 5px;
  margin-top: 0px;
  min-width: 0;
}
.statistics-items__item {
  position: relative;
  display: flex;
  padding: 15px;
  width: 100%;
  border-radius: 12px;
  background: #1e2025;
  color: #737373;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
}
.statistics-items__item-list {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 230px;
  min-height: 0;
  height: auto;
  padding-right: 4px;
  margin-top: 20px;
  min-width: 0;
}
.statistics-items__item-link {
  position: absolute;
  right: 15px;
  top: 15px;
  background: #141517;
  width: 35px;
  height: 35px;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
  transform: rotate(-45deg);
  cursor: pointer;
}
.statistics-items__item-link svg {
  width: 17px;
  height: 17px;
}
.statistics-items__item-link svg path {
  fill: #fff;
}
.statistics-items__item-link:hover {
  background: #000;
  transform: rotate(0deg);
}
.statistics-items__item-charts {
  position: relative;
  min-width: 0;
  max-width: 100%;
  width: 100%;
  margin-top: 20px;
}
.statistics-items__item-charts canvas {
  display: block;
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
}
.statistics-items__item-content {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: 30px;
  min-width: 0;
  width: 100%;
}
.statistics-items__item-content-counter {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 20px;
  min-width: 0;
}
.statistics-items__item-content-counter--column {
  flex-direction: column-reverse;
  align-items: flex-start;
  gap: 15px;
}
.statistics-items__item-content-counter-main {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}
.statistics-items__item-content-counter-main b {
  position: relative;
  display: inline-block;
  top: -1px;
  font-size: 12px;
  color: #fff;
  line-height: 100%;
}
.statistics-items__item-content-counter-main span {
  font-size: 14px;
}
.statistics-items__item-content-counter-main span:first-child {
  font-size: 24px;
  color: #fff;
}
.statistics-items__item-content-counter-total {
  position: relative;
  font-size: 11px;
  display: inline-flex;
  gap: 8px;
  flex-direction: column;
  padding: 8px 12px;
  border-radius: 12px;
  background: #131313;
  color: #fff;
  flex-shrink: 0;
  text-align: center;
  flex-wrap: wrap;
}
.statistics-items__item-content-counter-total span {
  display: flex;
  flex-direction: column;
}
.statistics-items__item-content-counter-total--row {
  flex-direction: row;
  text-align: center;
  gap: 2px;
  flex-wrap: unset;
  width: 100%;
}
.statistics-items__item-content-counter-total--row span {
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/StatisticsItems/StatisticsItems.scss"],"names":[],"mappings":"AAKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAJF;AAME;EACE,aAAA;EACA,kCAAA;EACA,SAAA;AAJJ;AAKI;EACE,sCAAA;AAHN;AAIM;EAFF;IAGI,oCAAA;EADN;AACF;AAII;EAXF;IAYI,8BAAA;EADJ;AACF;AAGI;EAfF;IAgBI,0BAAA;EAAJ;AACF;AAGE;EACE,aAAA;EACA,SAAA;EACA,eAAA;AADJ;AAIE;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAxCa;EAyCb,WAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFJ;AAII;EACE,gBAAA;AAFN;AAKI;EACE,mBAAA;AAHN;AASE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AAPJ;AAUE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AARJ;AAYE;EACE,WAAA;EACA,gBAAA;EACA,SAAA;AAVJ;AAYI;EACE,mBAlFW;EAmFX,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;AAVN;AAYM;EACE,gBAAA;AAVR;AAcI;EACE,aAAA;AAZN;AAeI;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAbN;AAgBI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAdN;AAiBQ;EACE,YAAA;AAfV;AAoBI;EACE,mBAAA;AAlBN;AAqBI;EACE,mBApIW;EAqIX,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;AAnBN;AAqBM;EACE,WAAA;EACA,kBAAA;AAnBR;AAqBQ;EACE,oCAAA;AAnBV;AAsBQ;EACE,cAAA;AApBV;AA4BE;EACE,WAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,SAAA;EACA,eAAA;AA3BJ;AA8BE;EACE,gBAAA;EACA,eAAA;AA5BJ;AA+BE;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,SAAA;EACA,WAAA;EAEA,YAAA;AA9BJ;AAgCI;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;EAEA,gBAAA;EACA,YAAA;EAEA,0CAAA;EACA,cAAA;AAjCN;AAkCM;EAlBF;IAmBI,WAAA;EA/BN;AACF;AAiCM;EACE,yCAAA;EACA,cAAA;AA/BR;AAkCM;EACE,yCAAA;EACA,cAAA;AAhCR;AAmCM;EACE,0CAAA;EACA,cAAA;AAjCR;AAoCM;EACE,0CAAA;EACA,cAAA;AAlCR;AAqCM;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAnCR;AAwCE;EACE,aAAA;EAEA,oDAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EAEA,SAAA;AAxCJ;AA2CE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAzCJ;AA4CE;EACE,aAAA;EACA,oBAAA;EACA,cAAA;EAEA,iBAAA;EACA,gBAAA;EACA,gBAAA;AA3CJ;AA6CI;EACE,WAAA;AA3CN;AA+CE;EACE;IACE,sBAAA;EA7CJ;EAgDE;IACE,0BAAA;IACA,WAAA;EA9CJ;EAiDE;IACE,2BAAA;IACA,gBAAA;IACA,YAAA;IACA,eAAA;EA/CJ;AACF;AAkDE;EAEE,aAAA;EACA,kCAAA;EACA,QAAA;EACA,eAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;AAjDJ;AAkDI;EACE,qCAAA;AAhDN;AAkDI;EACE,aAAA;EACA,QAAA;EACA,WAAA;EACA,yCAAA;AAhDN;AAkDI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAhDN;AAkDM;EACE,cAAA;EACA,aAAA;EACA,sBAAA;AAhDR;AAkDQ;EACE,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;AAhDV;AAmDQ;EACE,eAAA;AAjDV;AAmDU;EACE,eAAA;EACA,WAAA;AAjDZ;AAsDM;EACE,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,QAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AApDR;AAsDQ;EACE,aAAA;EACA,sBAAA;AApDV;AAuDQ;EACE,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;AArDV;AAuDU;EACE,aAAA;EACA,sBAAA;AArDZ;AA0DI;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAxDN;AAyDM;EACE,yBAAA;EACA,0CAAA;AAvDR;AA4DE;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;AA1DJ;AA6DE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAxYa;EAyYb,cAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;AA3DJ;AA6DI;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AA3DN;AA8DI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,mBA9Za;EA+Zb,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;AA5DN;AA8DM;EACE,WAAA;EACA,YAAA;AA5DR;AA8DQ;EACE,UAAA;AA5DV;AAgEM;EACE,gBAAA;EACA,uBAAA;AA9DR;AAkEI;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAhEN;AAkEM;EACE,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;AAhER;AAoEI;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AAlEN;AAoEM;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;AAlER;AAoEQ;EACE,8BAAA;EACA,uBAAA;EACA,SAAA;AAlEV;AAqEQ;EACE,cAAA;EACA,aAAA;EACA,sBAAA;AAnEV;AAqEU;EACE,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;AAnEZ;AAsEU;EACE,eAAA;AApEZ;AAsEY;EACE,eAAA;EACA,WAAA;AApEd;AAyEQ;EACE,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,QAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAvEV;AAyEU;EACE,aAAA;EACA,sBAAA;AAvEZ;AA0EU;EACE,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;AAxEZ;AAyEY;EACE,aAAA;EACA,sBAAA;AAvEd","sourcesContent":["@import '../../../styles/_variables';\r\n\r\n$elements-color: #1e2025;\r\n$additional-color: #141517;\r\n\r\n.statistics-items {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n\r\n  &__list {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr 1fr ;\r\n    gap: 20px;\r\n    &-big{\r\n      grid-template-columns: 1.4fr 1fr 0.6fr ;\r\n      @media (max-width:1920px){\r\n        grid-template-columns: 1.2fr 1fr 1fr ;\r\n      }\r\n    }\r\n\r\n    @media (max-width: 1500px) {\r\n      grid-template-columns: 1fr 1fr;\r\n    }\r\n\r\n    @media (max-width: 992px) {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  }\r\n\r\n  &__transfer-tabs {\r\n    display: flex;\r\n    gap: 10px;\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  &__transfer-tab {\r\n    border: 0;\r\n    padding: 10px 14px;\r\n    border-radius: 12px;\r\n    cursor: pointer;\r\n    background: $elements-color;\r\n    color: #fff;\r\n    font-size: 16px;\r\n    transition: all 0.2s ease;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    &:hover {\r\n      background: #000;\r\n    }\r\n\r\n    &--active {\r\n      background: #131313;\r\n    }\r\n  }\r\n\r\n  // --- НОВЫЕ СТИЛИ ДЛЯ ГРАФИКА ---\r\n\r\n  &__chart-controls {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    gap: 15px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  &__chart-group {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  // Стилизация Select под Tab (Кнопку)\r\n  .select-tab {\r\n    width: auto;\r\n    min-width: 100px;\r\n    margin: 0;\r\n\r\n    .select__active {\r\n      background: $elements-color;\r\n      border: 0;\r\n      border-radius: 12px;\r\n      padding: 10px 14px;\r\n      height: auto;\r\n      min-height: 40px;\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 10px;\r\n      transition: all 0.2s ease;\r\n\r\n      &:hover {\r\n        background: #000;\r\n      }\r\n    }\r\n\r\n    .select__label {\r\n      display: none;\r\n    }\r\n\r\n    .select__current {\r\n      font-size: 16px;\r\n      color: #fff;\r\n      font-weight: 400;\r\n      padding: 0;\r\n      margin: 0;\r\n    }\r\n\r\n    .select__arrow {\r\n      position: relative;\r\n      right: auto;\r\n      top: auto;\r\n      transform: none;\r\n      display: flex;\r\n      align-items: center;\r\n      width: auto;\r\n      height: auto;\r\n\r\n      svg {\r\n        path {\r\n          stroke: #fff;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.active .select__active {\r\n      background: #131313;\r\n    }\r\n\r\n    .select__items {\r\n      background: $elements-color;\r\n      border: 1px solid #333;\r\n      border-radius: 12px;\r\n      margin-top: 5px;\r\n      box-shadow: 0 10px 20px rgba(0,0,0,0.5);\r\n\r\n      .select__item {\r\n        color: #fff;\r\n        padding: 10px 14px;\r\n\r\n        &:hover {\r\n          background: rgba(255, 255, 255, 0.1);\r\n        }\r\n\r\n        &.active {\r\n          color: #277DFF;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // --- КОНЕЦ НОВЫХ СТИЛЕЙ ---\r\n\r\n  &__filter {\r\n    width: 100%;\r\n  }\r\n\r\n  &__filter-row {\r\n    display: flex;\r\n    gap: 12px;\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  &__filter-field {\r\n    min-width: 220px;\r\n    flex: 1 1 220px;\r\n  }\r\n\r\n  &__periods {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: stretch;\r\n    gap: 12px;\r\n    width: 100%;\r\n    // Не даём содержимому раздувать контейнер\r\n    min-width: 0;\r\n\r\n    &-grid > div,\r\n    &-all > div {\r\n      position: relative;\r\n      display: inline-flex;\r\n      flex-direction: column;\r\n      justify-content: center;\r\n      padding: 3px 10px;\r\n      border-radius: 6px;\r\n      font-size: 18px;\r\n      transition: all 0.2s ease;\r\n      min-height: 48px;\r\n      box-sizing: border-box;\r\n      // Не даём плашке расти от контента\r\n      overflow: hidden;\r\n      min-width: 0;\r\n\r\n      background-color: rgba(39, 125, 255, 0.13);\r\n      color: #277DFF;\r\n      @media (max-width:767px){\r\n        width: 100%;\r\n      }\r\n\r\n      &.is-green {\r\n        background-color: rgba(0, 227, 150, 0.13);\r\n        color: #00E396;\r\n      }\r\n\r\n      &.is-red {\r\n        background-color: rgba(255, 69, 96, 0.13);\r\n        color: #FF4560;\r\n      }\r\n\r\n      &.is-purple {\r\n        background-color: rgba(119, 93, 208, 0.13);\r\n        color: #775DD0;\r\n      }\r\n\r\n      &.is-orange {\r\n        background-color: rgba(254, 176, 25, 0.13);\r\n        color: #FEB019;\r\n      }\r\n\r\n      span {\r\n        color: #fff;\r\n        font-size: 12px;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n      }\r\n    }\r\n  }\r\n\r\n  &__periods-grid {\r\n    display: grid;\r\n    // minmax(0, 1fr) не даёт ячейкам расширяться больше своей доли\r\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\r\n    gap: 8px 12px;\r\n    align-content: flex-start;\r\n    width: 100%;\r\n    min-width: 0;\r\n    // Грид занимает ровно свою часть, не больше\r\n    flex: 1 1 0;\r\n  }\r\n\r\n  &__periods-price{\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  &__periods-all {\r\n    display: flex;\r\n    align-items: stretch;\r\n    flex-shrink: 0;\r\n    // Фиксированная ширина для плашки \"за всё время\"\r\n    flex-basis: 150px;\r\n    min-width: 150px;\r\n    max-width: 150px;\r\n\r\n    & > div {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 576px) {\r\n    &__periods {\r\n      flex-direction: column;\r\n    }\r\n\r\n    &__periods-grid {\r\n      grid-template-columns: 1fr;\r\n      flex: unset;\r\n    }\r\n\r\n    &__periods-all {\r\n      justify-content: flex-start;\r\n      flex-basis: auto;\r\n      min-width: 0;\r\n      max-width: none;\r\n    }\r\n  }\r\n\r\n  &__list-selector{\r\n    $selfSelector: &;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n    gap:3px;\r\n    max-width: 100%;\r\n    align-items: flex-start;\r\n    align-content: flex-start;\r\n    max-height: 300px;\r\n    overflow: auto;\r\n    &--small{\r\n      grid-template-columns: 1fr !important;\r\n    }\r\n    &-group{\r\n      display: grid;\r\n      gap:3px;\r\n      width: 100%;\r\n      grid-template-columns: 1fr 1fr !important;\r\n    }\r\n    &-counter{\r\n      width: 100%;\r\n      display: flex;\r\n      flex-direction: row;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      gap: 8px;\r\n\r\n      &-main {\r\n        flex-shrink: 0;\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        b {\r\n          position: relative;\r\n          display: inline-block;\r\n          top: -1px;\r\n          font-size: 12px;\r\n          color: #fff;\r\n          line-height: 100%;\r\n        }\r\n\r\n        span {\r\n          font-size: 12px;\r\n\r\n          &:first-child {\r\n            font-size: 20px;\r\n            color: #fff;\r\n          }\r\n        }\r\n      }\r\n\r\n      &-total {\r\n        position: relative;\r\n        font-size: 11px;\r\n        display: inline-flex;\r\n        gap: 8px;\r\n        flex-direction: column;\r\n        padding: 8px 12px;\r\n        border-radius: 12px;\r\n        background: #131313;\r\n        color: #fff;\r\n        flex-shrink: 0;\r\n        text-align: center;\r\n        flex-wrap: wrap;\r\n\r\n        span{\r\n          display: flex;\r\n          flex-direction: column;\r\n        }\r\n\r\n        &--row{\r\n          flex-direction: row;\r\n          text-align: center;\r\n          gap: 2px;\r\n          flex-wrap: unset;\r\n          width: 100%;\r\n\r\n          span{\r\n            display: flex;\r\n            flex-direction: column;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    &-item{\r\n      padding: 5px;\r\n      border-radius: 12px;\r\n      cursor: pointer;\r\n      &--active{\r\n        border: 1px solid #2670dc;\r\n        background-color: rgba(39, 125, 255, 0.13);\r\n      }\r\n    }\r\n  }\r\n\r\n  &__inner{\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column-reverse;\r\n    justify-content: space-between;\r\n    gap: 5px;\r\n    margin-top: 0px;\r\n    min-width: 0;\r\n  }\r\n\r\n  &__item {\r\n    position: relative;\r\n    display: flex;\r\n    padding: 15px;\r\n    width: 100%;\r\n    border-radius: 12px;\r\n    background: $elements-color;\r\n    color: #737373;\r\n    flex-direction: column;\r\n    min-height: 0;\r\n    min-width: 0;\r\n\r\n    &-list {\r\n      display: flex;\r\n      flex-direction: column;\r\n      overflow-y: auto;\r\n      overflow-x: hidden;\r\n      max-height: 230px;\r\n      min-height: 0;\r\n      height: auto;\r\n      padding-right: 4px;\r\n      margin-top: 20px;\r\n      min-width: 0;\r\n    }\r\n\r\n    &-link {\r\n      position: absolute;\r\n      right: 15px;\r\n      top: 15px;\r\n      background: $additional-color;\r\n      width: 35px;\r\n      height: 35px;\r\n      border-radius: 30px;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      transition: all 0.3s ease;\r\n      transform: rotate(-45deg);\r\n      cursor: pointer;\r\n\r\n      svg {\r\n        width: 17px;\r\n        height: 17px;\r\n\r\n        path {\r\n          fill: #fff;\r\n        }\r\n      }\r\n\r\n      &:hover {\r\n        background: #000;\r\n        transform: rotate(0deg);\r\n      }\r\n    }\r\n\r\n    &-charts{\r\n      position: relative;\r\n      min-width: 0;\r\n      max-width: 100%;\r\n      width: 100%;\r\n      margin-top: 20px;\r\n\r\n      canvas{\r\n        display: block;\r\n        width: 100% !important;\r\n        height: 100% !important;\r\n        max-width: 100% !important;\r\n      }\r\n    }\r\n\r\n    &-content {\r\n      display: flex;\r\n      align-items: flex-end;\r\n      justify-content: space-between;\r\n      margin-top: 30px;\r\n      min-width: 0;\r\n      width: 100%;\r\n\r\n      &-counter {\r\n        width: 100%;\r\n        display: flex;\r\n        flex-direction: row;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        gap: 8px;\r\n        margin-bottom: 20px;\r\n        min-width: 0;\r\n\r\n        &--column{\r\n          flex-direction: column-reverse;\r\n          align-items: flex-start;\r\n          gap: 15px;\r\n        }\r\n\r\n        &-main {\r\n          flex-shrink: 0;\r\n          display: flex;\r\n          flex-direction: column;\r\n\r\n          b {\r\n            position: relative;\r\n            display: inline-block;\r\n            top: -1px;\r\n            font-size: 12px;\r\n            color: #fff;\r\n            line-height: 100%;\r\n          }\r\n\r\n          span {\r\n            font-size: 14px;\r\n\r\n            &:first-child {\r\n              font-size: 24px;\r\n              color: #fff;\r\n            }\r\n          }\r\n        }\r\n\r\n        &-total {\r\n          position: relative;\r\n          font-size: 11px;\r\n          display: inline-flex;\r\n          gap: 8px;\r\n          flex-direction: column;\r\n          padding: 8px 12px;\r\n          border-radius: 12px;\r\n          background: #131313;\r\n          color: #fff;\r\n          flex-shrink: 0;\r\n          text-align: center;\r\n          flex-wrap: wrap;\r\n\r\n          span{\r\n            display: flex;\r\n            flex-direction: column;\r\n          }\r\n\r\n          &--row{\r\n            flex-direction: row;\r\n            text-align: center;\r\n            gap: 2px;\r\n            flex-wrap: unset;\r\n            width: 100%;\r\n            span{\r\n              display: flex;\r\n              flex-direction: column;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
